import React from "react";
import loadingSvg from "../../assets/svg/loading.svg";

export default function UnderMaintenance() {
    return (
        <div className="maintenance">
            <div className="maintenance__card">
                <img
                    src={loadingSvg}
                    alt="Loading"
                    className="maintenance__icon"
                />

                <h1 className="maintenance__title">
                    We’ll Be Back Soon
                </h1>

                <p className="maintenance__desc">
                   We are sorry, Our website is currently undergoing scheduled maintenance.
                </p>

                <p className="maintenance__desc maintenance__desc--id">
                    Mohon Maaf, Situs kami sedang dalam proses pemeliharaan terjadwal.
                </p>

                        <span className="maintenance__note">
            Thank you for your patience · Terima kasih atas kesabaran Anda
        </span>

            </div>
        </div>
    );
}
